var map = {
	"./CCPH_rightWrong.json": 7611,
	"./CMH_rightWrong.json": 702,
	"./MaoIntro_rightWrong.json": 617,
	"./Marx_rightWrong.json": 3866,
	"./NCH_rightWrong.json": 5947,
	"./ORH_rightWrong.json": 368,
	"./Political_rightWrong.json": 6129,
	"./SDH_rightWrong.json": 7191,
	"./XiIntro_rightWrong.json": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3001;